import { AttributeTypes, UserProfileTypes, AttributePropertyTypes, AttributeRules, AttributeIcons } from '../enum';

export const getAllAttributeTypes = () => {
    return [
        { id: 1, name: 'Heading', value: AttributeTypes.HEADING },
        { id: 2, name: 'Sub Heading', value: AttributeTypes.SUB_HEADING },
        { id: 3, name: 'Free Text', value: AttributeTypes.STATIC_TEXT },
        { id: 4, name: 'Input Text', value: AttributeTypes.INPUT_TEXT },
        { id: 5, name: 'Number', value: AttributeTypes.NUMBER },
        { id: 6, name: 'Long Text', value: AttributeTypes.LONG_INPUT_TEXT },
        { id: 7, name: 'Date', value: AttributeTypes.DATE },
        { id: 8, name: 'Dropdown', value: AttributeTypes.DROP_DOWN },
        { id: 9, name: 'Multi Select', value: AttributeTypes.MULTI_DROP_DOWN },
        { id: 10, name: 'Radiobutton', value: AttributeTypes.RADIO },
        { id: 11, name: 'Checkbox', value: AttributeTypes.CHECKBOX },
        { id: 12, name: 'Duration', value: AttributeTypes.DURATION },
    ];
};
export const getInputTypeCategories = () => {
    return [
        { id: 1, name: 'Static Texts ', value: [AttributeTypes.HEADING, AttributeTypes.SUB_HEADING, AttributeTypes.STATIC_TEXT] },
        { id: 2, name: 'Input Text ', value: [AttributeTypes.INPUT_TEXT, AttributeTypes.LONG_INPUT_TEXT] },
        { id: 3, name: 'Numeric ', value: [AttributeTypes.NUMBER] },
        { id: 4, name: 'Date', value: [AttributeTypes.DATE] },
        { id: 5, name: 'Options', value: [AttributeTypes.DROP_DOWN, AttributeTypes.MULTI_DROP_DOWN, AttributeTypes.RADIO, AttributeTypes.CHECKBOX] },
        { id: 6, name: 'Duration', value: [AttributeTypes.DURATION] },
    ];
};
export const getUserProfileTypes = () => {
    return [
        { name: 'Normal', value: UserProfileTypes.NORMAL },
        { name: 'User Profile', value: UserProfileTypes.USER_PROFILE },
        { name: 'Both', value: UserProfileTypes.BOTH },
    ];
};

export const getAttributePropertyTypes = () => {
    return [
        { name: 'Standard Attribute', code: AttributePropertyTypes.NORMAL },
        { name: 'Tagged Attribute', code: AttributePropertyTypes.TAGGED },
    ];
};

export const getAttributeTaggedOptions = () => {
    return [
        { name: 'True', value: true },
        { name: 'False', value: false },
    ];
};

export const getAttributeValidationRules = () => {
    return [
        { name: 'Minimum Value', code: AttributeRules.MINIMUM_VALUE, checked: null },
        { name: 'Maximum Value', code: AttributeRules.MAXIMUM_VALUE, checked: null },
        { name: 'Minimum Length', code: AttributeRules.MINIMUM_LENGTH, checked: null },
        { name: 'Maximum Length', code: AttributeRules.MAXIMUM_LENGTH, checked: null },
    ];
};

export const getAttributeIcons = () => {
    let iconArr = [];
    for (var i = 1; i <= 120; i++) {
        iconArr.push({ id: i, value: AttributeIcons['ICON_' + i], name: 'Icon ' + i });
    }
    return iconArr;
};
